import React from 'react';

import withTransitionHook from 'client/helpers/withTransitionHook';
import SalesRepActions from 'client/actions/SalesRep';

import SrPartnerSignUpForm from 'client/components/SrPartnerSignUpForm/SrPartnerSignUpForm';

@withTransitionHook
class PartnerSignUpPage extends React.Component {
  static getPageMetadata = () => ({
    pageTitle: 'Get Started | Sunroom Rentals',
    section: 'Onboarding',
  });

  static fetchData(state, inject) {
    return Promise.all([SalesRepActions.getSalesRepList(inject)]);
  }

  render() {
    return (
      <SrPartnerSignUpForm
        navbarImage="/images/SRlogo.svg"
        pageHeader="Signup to Simplify Your Leasing"
        pageSubtitle="When you partner with Sunroom, you get an entire leasing
          team and a technology platform. We help you keep track of your properties
          in real-time, find quality applicants, and get a lease signed 26% faster than the market average."
      />
    );
  }
}

PartnerSignUpPage.displayName = 'PartnerSignUpPage';

export default PartnerSignUpPage;
